import useShallowEqualSelector from '../../../custom_hooks/useShallowEqualsSelector';
import { ReducerKeys } from '../../../redux/reducers';
import { StateStatus } from '../../utils/common';
import * as VatReturnRemindersService from '../../../services/api/vatReturn_reminders';
import { useSelector } from 'react-redux';
import { IState } from './reducer';

interface VatReturnRemindersListOutput {
  status: StateStatus;
  data: VatReturnRemindersService.IVatReturnRemindersListOutput | null;
}

export const useGetVatReturnRemindersList =
  (): VatReturnRemindersListOutput => {
    const data = useShallowEqualSelector(
      (state: any) =>
        state[ReducerKeys.VATRETURN_REMINDER_REDUCER].vatReturnRemindersList
    );
    return data;
  };

export const useGetVatReturnRemindersGenerateStatus = ():
  | StateStatus
  | undefined => {
  const data = useSelector(
    (state: any) =>
      (state[ReducerKeys.VATRETURN_REMINDER_REDUCER] as IState)
        .vatReturnRemindersGenerateStatus
  );
  return data;
};
